import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Directive, Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldResult} from '../model/api/field-result';
import {FieldRecord} from '../model/api/field-record';
import {SessionNames} from "../shared/session/session-names";
import {CCRolesType} from "../model/security/cc-roles-type";
import {DateTime} from "luxon";
import {CcBaseComponent} from "./cc-base.component";
import {ProgressTracker} from "../model/api/progress-tracker";

@Directive()
export abstract class CcBaseFormComponent<T = any> extends CcBaseComponent {

  @Input()
  formRecord: T;

  tracker: ProgressTracker;

  @Input()
  settingsFormLoadingProgressValue: number = 100;
}
